import { render } from "./OrderOver.vue?vue&type=template&id=11319ef4&scoped=true"
import script from "./OrderOver.vue?vue&type=script&lang=js"
export * from "./OrderOver.vue?vue&type=script&lang=js"

import "./OrderOver.vue?vue&type=style&index=0&id=11319ef4&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11319ef4"]])

export default __exports__